import script from "./HotSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotSearch.vue?vue&type=script&lang=ts&setup=true"

import "./HotSearch.vue?vue&type=style&index=0&id=743942a8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743942a8"]])

export default __exports__